import React from 'react'
import {connectHits} from 'react-instantsearch-dom'
import {Row} from '@bootstrap-styled/v4'

const Hits = ({hits, Hit}) => (
    <Row>
        {hits.map(hit => (<Hit hit={hit}/>))}

        {hits.length < 1 && 

        (<div
            style={{
            display: 'flex',
            justifyContent: 'center',
            width: '90%',
            margin: '0 auto',
            animation: 'fadeIn 1.3s'
        }}>
            <h2 style={{
                textAlign: 'center',
            }}>
                <span
                    style={{
                    display: 'block',
                    fontSize: '2em',
                    color: 'var(--primary)'
                }}>
                    Oops,
                </span>
                Não encontramos resultados :(</h2>
        </div>)
}
    </Row>

);

export default connectHits(Hits)